import { ITINERARYDETAILS } from "src/common/constants";
import {
  IntineraryDetailsAction,
  ItineraryI,
} from "../reducers/itineraryDetails";
export const ITINERARYDETAILS_FETCH_DATA =
  `${ITINERARYDETAILS}_GET_DATA` as const;
export const ITINERARYDETAILS_FETCH_DATA_CUSTOM_DATES =
  `${ITINERARYDETAILS}_GET_DATA_CUSTOM_DATES` as const;
export const ITINERARYDETAILS_FETCH_INVOKED =
  `${ITINERARYDETAILS}_GET_INVOKED` as const;
export const ITINERARYDETAILS_FETCH_SUCCESS =
  `${ITINERARYDETAILS}_GET_SUCCESS` as const;
export const ITINERARYDETAILS_FETCH_FAILED =
  `${ITINERARYDETAILS}_GET_FAILED` as const;

export const fetchItineraryDetails = (
  id: string,
  timeFrames?: { previous: number; upcoming: number }
) => {
  return {
    type: ITINERARYDETAILS_FETCH_DATA,
    timeFrames,
    id,
  };
};
export const fetchItineraryDetailsCustomDates = ({
  startDate,
  endDate,
  id,
}: {
  startDate: moment.Moment;
  endDate: moment.Moment;
  id: string;
}) => ({
  type: ITINERARYDETAILS_FETCH_DATA_CUSTOM_DATES,
  startDate,
  endDate,
  id,
});
export const fetchItineraryDetailsInvoked = (
  id: string
): IntineraryDetailsAction => ({
  type: ITINERARYDETAILS_FETCH_INVOKED,
  id,
});
export const fetchItineraryDetailsSuccess = (
  payload: ItineraryI[],
  id: string,
  showDebtorName: boolean
): IntineraryDetailsAction => ({
  type: ITINERARYDETAILS_FETCH_SUCCESS,
  payload,
  id,
  showDebtorName,
});
export const fetchItineraryDetailsFailed = (
  error: Error,
  id: string
): IntineraryDetailsAction => ({
  type: ITINERARYDETAILS_FETCH_FAILED,
  error,
  id,
});
